import React from 'react'
import { render } from 'react-dom'
import App from './App'
import './style.scss'
import './dark.scss'

render(<App />, document.querySelector('#app'))
